/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CreateComplianceStandardRequest extends models.ComplianceStandardBase {
    getFixupPrototypeFunction() { return CreateComplianceStandardRequest.fixupPrototype; }

    static newInstance(model: Partial<CreateComplianceStandardRequest>): CreateComplianceStandardRequest {
        let obj = Object.assign(new CreateComplianceStandardRequest(), model);
        CreateComplianceStandardRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CreateComplianceStandardRequest>): CreateComplianceStandardRequest {
        if (!model) return null;
        return CreateComplianceStandardRequest.newInstance(<CreateComplianceStandardRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CreateComplianceStandardRequest) {
        if (!obj) return;

        models.CreateComplianceStandardRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CreateComplianceStandardRequest): boolean {
        if (models.ComplianceStandardBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CreateComplianceStandardRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.controls_definition_content) {
            models.ControlsDefinitionContent.fixupPrototype(this.controls_definition_content);
        }
    }

    /**
     * Tenant ID associated with the standard
     */
    tenant_id: string;

    /**
     * Cloud providers this standard applies to (e.g., AWS, Azure, GCP)
     */
    supported_cloud_providers: Array<models.CloudServiceName>;

    /**
     * CSV/XLSX file with control definitions
     */
    controls_definition_content: models.ControlsDefinitionContent;

}
